import React from 'react';
import { EVENT } from '../../models/Event';
import { dispatchCustomEvent } from '../../utils/dispatchCustomEvent';
import { useCustomEventListener } from '../../hooks/useCustomEventsListener';

/**
 * Custom hook for adding a donation/impact item to the gift cart.
 *
 * - dispatchNewCartItem() sends the new cart item.
 * - cartIsOpen is true when the cart item is sent, and then set to false when
 *   Whammy has closed the gift cart modal.
 *
 * This hooks assumes the following:
 * - Whammy is listening for EVENT.CART_ADD_ITEM.
 * - When Whammy closes the gift cart modal, it fires off a EVENT.CART_MODAL_CLOSED event.
 */
export function useAddCartItem() {
  const [cartIsOpen, setCartIsOpen] = React.useState(false);
  const dispatchNewCartItem = React.useCallback(cartItem => {
    dispatchCustomEvent(EVENT.CART_ADD_ITEM, cartItem);
    dispatchCustomEvent(EVENT.CART_OPEN_MODAL);
    setCartIsOpen(true);
  }, []);
  const isModalClosed = useCustomEventListener(EVENT.CART_MODAL_CLOSED, {});
  React.useEffect(() => {
    setCartIsOpen(false);
  }, [isModalClosed]);
  return {
    dispatchNewCartItem,
    cartIsOpen
  };
}